"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SVG = _interopRequireDefault(require("./SVG"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChevronUpIcon = function ChevronUpIcon(_ref) {
  var width = _ref.width,
      height = _ref.height,
      style = _ref.style,
      viewBox = _ref.viewBox,
      fill = _ref.fill,
      className = _ref.className;
  return /*#__PURE__*/_react.default.createElement(_SVG.default, {
    style: style,
    width: width || '32',
    height: height || '32',
    viewBox: viewBox || "0 0 32 32",
    fill: fill,
    className: className,
    path: "M16 10.4142L6.70711 19.7071C6.31658 20.0976 5.68342 20.0976 5.29289 19.7071C4.90237 19.3166 4.90237 18.6834 5.29289 18.2929L15.2929 8.29289C15.6834 7.90237 16.3166 7.90237 16.7071 8.29289L26.7071 18.2929C27.0976 18.6834 27.0976 19.3166 26.7071 19.7071C26.3166 20.0976 25.6834 20.0976 25.2929 19.7071L16 10.4142Z"
  });
};

var _default = ChevronUpIcon;
exports.default = _default;